import { render, staticRenderFns } from "./InvestmentContainerTemplate.vue?vue&type=template&id=7cb78753&scoped=true"
import script from "./InvestmentContainerTemplate.vue?vue&type=script&lang=ts"
export * from "./InvestmentContainerTemplate.vue?vue&type=script&lang=ts"
import style0 from "./InvestmentContainerTemplate.vue?vue&type=style&index=0&id=7cb78753&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb78753",
  null
  
)

export default component.exports